import React, { useState, useEffect } from 'react'
import { trans } from '../../../../_providers/Translation'
import Dropdown from '../../../partials/Dropdown'
import inIcon from '../../../../assets/img/icons/phone/incomming.png'
import outIcon from '../../../../assets/img/icons/phone/outgoing.png'
import missIcon from '../../../../assets/img/icons/phone/missed.png'
import cancelIcon from '../../../../assets/img/icons/phone/canceled.png'
import DateRange from '@/components/partials/DateRange'
import { FormControlLabel, Radio } from '@mui/material'

function FilterStats(props) {

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleGroup = (e, val) => {
        e.preventDefault()

        props.handleSearch('group', val)
    }

    const handleStatus = data => {

        let val = data.id || ''

        props.handleSearch('status', val)
    }

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleClearFilters = () => {
        props.handleSearch('status', '')
        props.handleSearch('start', '')
        props.handleSearch('end', '')
        props.toggleSummaryData(true)
    }

    return (
        <form className="filter-standard schedule-filter">
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1">
                        {trans('filters.status')}
                    </option>
                    <option value="2">
                        {trans('filters.startDate')}
                    </option>
                    <option value="3">
                        {trans('filters.endDate')}
                    </option>

                </select>
            </div>

            <div className="col" data-id="1">
                <Dropdown
                    inputIdName="status_id"
                    inputIdValue={props.filter.status}
                    data={[
                        {
                            id: '',
                            name: "Всички статуси"
                        },
                        {
                            id: 'incomming',
                            name: trans('labels.incomming'),
                            icon: inIcon
                        },
                        {
                            id: 'outgoing',
                            name: trans('labels.outgoing'),
                            icon: outIcon
                        },
                        // {
                        //     id: 'missed',
                        //     name: trans('labels.missed'),
                        //     icon: missIcon
                        // },
                        // {
                        //     id: 'canceled',
                        //     name: trans('labels.canceled'),
                        //     icon: cancelIcon
                        // }
                    ]}
                    renderInputText={data => {
                        return data.name
                    }}
                    renderText={data => {
                        return (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '20px', height: '20px', marginRight: '10px' }}>
                                    {data.icon && <img src={data.icon} style={{ width: '100%', height: '100%' }} />}
                                </div>
                                <span>{data.name}</span>
                            </div>
                        )
                    }}
                    filterable={false}
                    onChange={data => {
                        handleStatus(data)
                    }}
                />

            </div>

            <div className="col" data-id="2">
                <DateRange
                    startDate={props.filter.start}
                    endDate={props.filter.end}
                    onStartDateChange={(date) => {
                        props.handleSearch('start', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('end', date)
                    }}
                />
            </div>

            <div className="col" data-id="4" style={{ justifyContent: 'center' }}>
                <div style={{ display: 'flex' }}>
                    {props.allowDetails
                        ?
                        <div className="col">
                            <FormControlLabel
                                control={
                                    <Radio
                                        name='summary'
                                    />
                                }
                                checked={!props.summary}
                                onClick={() => props.toggleSummaryData(false)}
                                label={trans('random.inDetail')}
                            />
                        </div>
                        :
                        ''
                    }

                    <div className="col">
                        <FormControlLabel
                            control={
                                <Radio
                                    name='summary'
                                />
                            }
                            checked={props.summary}
                            onClick={() => props.toggleSummaryData(true)}
                            label={trans('random.summarized')}
                        />
                    </div>
                </div>
            </div>
            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    {trans('buttons.clearFilter')}
                </button>
            </div>

            <div className="group">
                <label>
                    {trans('labels.groupBy')}
                </label>
                <button
                    className={props.filter.group === 'month' ? 'active' : ''}
                    onClick={e => handleGroup(e, 'month')}
                >
                    {trans('buttons.month')}
                </button>
                <button
                    className={props.filter.group === 'year' ? 'active' : ''}
                    onClick={e => handleGroup(e, 'year')}
                >
                    {trans('buttons.year')}
                </button>
            </div>

        </form>
    )
}

export default React.memo(FilterStats, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})